import React from 'react';
import { Input } from "@shadcn-in-nx/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";

export function DatetimeInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSave(value);
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  const getLocalFormattedValue = (val) => {
    if (!val) return '';
    const d = new Date(val);
    if (isNaN(d.getTime())) {
      return typeof val === 'string' ? val.substring(0, 16) : '';
    }
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const formattedValue = getLocalFormattedValue(value);

  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    if (!rawValue) {
      onChange(null);
    } else {
      const d = new Date(rawValue);
      if (!isNaN(d.getTime())) {
        onChange(d.toISOString());
      } else {
        onChange(rawValue);
      }
    }
  };

  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  return (
    <div className='h-full w-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Input
                type="datetime-local"
                value={formattedValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onBlur={() => onSave(value)}
                autoFocus={autoFocus}
                min={schema?.minimum}
                max={schema?.maximum}
                className={errorClass}
              />
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
